import PaginationParams from './PaginationParams'
import DocumentTypes from './DocumentTypes'
import City from './City'
import { TelephoneType } from './TelephoneType';

export enum studentTypes {
    active = 'ACTIVE',
    inactive = 'INACTIVE'
}
export default interface Student {
    id: string
    document_type: DocumentTypes
    document_number: string
    name: string
    last_name: string
    state: studentTypes,
    email: string
    telephone: string
    telephone_type: TelephoneType
    city: City
}

export type studentSearchParams = PaginationParams & {
    document_type?: DocumentTypes
    document_number?: string
}
